import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';

import { Grid } from '../../../lib/grid';
import { Row } from '../../../lib/data-set/row';

@Component({
    selector: 'ng2-st-actions',
    template: `
    <a
      href="#"
      class="ng2-smart-action ng2-smart-action-add-create"
      [innerHTML]="createButtonContent"
      (click)="$event.preventDefault(); create.emit($event)"
    ></a>
    <a
      href="#"
      class="ng2-smart-action ng2-smart-action-add-cancel"
      [innerHTML]="cancelButtonContent"
      (click)="onAddCancel($event)"
    ></a>
  `,
    standalone: false
})
export class ActionsComponent implements OnChanges {
  @Input() public grid: Grid;
  @Output() public create = new EventEmitter<any>();
  @Output() public addCancel = new EventEmitter<any>();
  @Input() public row: Row;

  public createButtonContent: string;
  public cancelButtonContent: string;

  public ngOnChanges() {
    this.createButtonContent = this.grid.getSetting('add.createButtonContent');
    this.cancelButtonContent = this.grid.getSetting('add.cancelButtonContent');
  }

  public onAddCancel(event: any) {
    event.preventDefault();
    this.grid.createFormShown = false;
    this.grid.dataSet.newRowValidator.reset();
    this.addCancel.emit();
  }
}
